import React from 'react';
import ReactModal from 'react-modal';

ReactModal.setAppElement('*');

export function Modal({ children, style, width, maxHeight = "70vh", ...rest }) {
  return (
    <ReactModal
      style={{
        overlay: {
          zIndex: 99,
          width: '100%',
        },
        content: {
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: width || '80%',
          maxWidth: '680px',
          height: 'auto',
          maxHeight,
          position: 'relative',
          fontSize: '18px',
        },
        ...style,
      }}
      testId={rest['data-testid']}
      {...rest}
    >
      <div>{children}</div>
    </ReactModal>
  );
}
